import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AlertTriangle } from "lucide-react";
import { ALERT } from "@/constants/testIds";

export default function AlertBanner() {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    const load = () =>
      api.get("/weather/alerts").then((r) => setAlerts(r.data.alerts || [])).catch(() => {});
    load();
    const t = setInterval(load, 60_000);
    return () => clearInterval(t);
  }, []);

  if (!alerts.length) {
    return (
      <div data-testid={ALERT.banner} className="border-y border-white/10 bg-black/70">
        <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-2 text-sm text-gray-300 sm:px-6">
          <span className="font-oswald text-xs uppercase tracking-[0.3em] text-emerald-400">All Clear</span>
          <span className="text-gray-400">No active severe weather alerts for Georgia.</span>
        </div>
      </div>
    );
  }

  return (
    <div data-testid={ALERT.banner} className="stripe-red border-y-2 border-black">
      <div className="flex items-center gap-3 bg-[#d90429] px-4 py-2">
        <AlertTriangle className="h-4 w-4 shrink-0 text-white" />
        <span className="font-oswald text-xs font-bold uppercase tracking-[0.3em] text-white">
          Severe Weather Alerts
        </span>
        <span className="rounded bg-black/30 px-2 py-0.5 font-mono text-[10px] text-white">
          {alerts.length} active
        </span>
      </div>
      <div className="overflow-hidden bg-[#a3031e]" data-testid={ALERT.ticker}>
        <div className="marquee-track py-2">
          {[...alerts, ...alerts].map((a, i) => (
            <span key={`${a.id || a.title}-${i}`} className="mx-6 whitespace-nowrap font-oswald text-sm uppercase tracking-wider text-white">
              <span className="mr-2 rounded bg-black/40 px-2 py-0.5 text-[10px]">{a.source || "NWS"}</span>
              <strong className="font-bold">{a.title}</strong>
              {a.area && <span className="ml-2 text-white/80">— {a.area}</span>}
              <span className="mx-6 text-white/50">◆</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
